module.exports = __webpack_public_path__ + "img/swiper-right-btn.f7885a04.svg";